
// Calculate age from DOB string (YYYY-MM-DD)
export const calcAge = (dob) => {
  if (!dob) return '';
  const today = new Date();
  const birth = new Date(dob);
  if (isNaN(birth)) return '';
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return String(age);
};

// Calculate hospital day (admission = Day 1)
export const hospDay = (admissionDate) => {
  if (!admissionDate) return null;
  const adm = new Date(admissionDate);
  if (isNaN(adm)) return null;
  const today = new Date();
  adm.setHours(0,0,0,0); today.setHours(0,0,0,0);
  return Math.floor((today - adm) / 86400000) + 1;
};

export const toDay  = () => new Date().toISOString().slice(0, 10);
export const toTime = () => new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
export const fmtDay = d => {
  try { return new Date(d + 'T12:00:00').toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' }); }
  catch { return d; }
};

export const newVD = () => ({ vBP: '', vHR: '', vRR: '', vT: '', vO2: '', vAVPU: 'A', vGCSe: '', vGCSv: '', vGCSm: '', date: toDay(), time: toTime() });

export const blankPt = (team = '') => ({
  id: `p${Date.now()}`,
  name: '', mrn: '', room: '', dob: '', admissionDate: '', age: '', sex: 'F',
  weight: '', weightUnit: 'kg',
  consultant: '',
  team, urgency: 'new', code: 'Primary',
  diagnosis: '', activeIssues: '', medications: '', allergies: '', note: '',
  cc: '', hpi: '', pmh: '', fh: '', psh: '', ros: '', pe: '',
  ivFluids: '',
  resus: 'full',
  lastReviewed: null,
  dischargeOrders: { medications: '', followUp: '', others: '' },
  todos: [], vitalsLog: [], labsLog: [], imagingLog: [], referLog: [], medsList: [], ivList: [],
  issuesList: [], resolvedIssues: [], ioLog: [], dietList: [], procedureList: [],
});

export const migrate = p => {
  const base = {
    vitalsLog: [], labsLog: [], imagingLog: [], referLog: [], medsList: [], ivList: [],
    issuesList: [], resolvedIssues: [], ioLog: [], dietList: [], procedureList: [],
    weight: '', weightUnit: 'kg',
    consultant: '',
    cc: '', hpi: '', pmh: '', fh: '', psh: '', ros: '', pe: '',
    ivFluids: '',
    resus: 'full',
    lastReviewed: null,
    dischargeOrders: { medications: '', followUp: '', others: '' },
    ...p,
  };
  base.todos = (p.todos || []).map((t, i) => ({ order: i, type: 'general', status: t.done ? 'Done' : 'Pending', priority: 'routine', ...t }));
  base.medsList = (p.medsList || []).map(m => ({ startDate: '', abxTotal: '', ...m }));
  return base;
};

export const byDate = arr =>
  arr.reduce((a, x) => { (a[x.date] = a[x.date] || []).push(x); return a; }, {});
